<script>
  import Chart from "svelte-chartjs/src/Bar.svelte";
  import { createEventDispatcher, onMount } from "svelte";
  import { generateCanvasGradient, makeWebsiteRequest, parseNumber, parsePercent, months, monthsShort } from "../../Common/tools";
import UtmLinkGenerator from "../UtmLinkGenerator.svelte";
  import {External, M} from "../../external";

  export let filters = [],
    grouping = "daily",
    funnel = null,
    period = null,
    showReferers = true;

  const upsellsColors = ["#FF55B8", "#FF8787"];
  const downsellsColors = ["#3da6ff", "#257cc6"];
  const bumpsColors = ["#ff9800", "#ffab2e"];

  let chartDataLabels = [];
  let monthLabels = [];
  let showMonthsBelow = false;
  let chartWrapper = null;

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: false,
      title: false,
      tooltip: {
        mode: "index",
        intersect: false,
        displayColors: false
      }
    },
    scales: {
      xAxes: {
        display: false,
        stacked: true
      },
      yAxes: {
        display: false,
        stacked: true
      }
    },
    layout: {
      padding: 3
    }
  };

  let chartData = {
    labels: [],
    datasets: []
  };

  let chartValues = [];
  let stats = {};

  const dispatch = createEventDispatcher();

  export async function reload() {
    let from, to;
    if (period && period.from) {
      from = External.Tools.dateToISOStr(period.from);
    }
    if (period && period.to) {
      to = External.Tools.dateToISOStr(period.to);
    }
    if (!from) {
      let firstOrderTime = External.Website.firstOrderTime;
      from = External.Tools.dateToISOStr(new Date(firstOrderTime || External.createdTime * 1000));
    }
    if (!to) {
      to = External.Tools.dateToISOStr(new Date());
    }

    let response = await makeWebsiteRequest({
      action: "getOrderStats",
      method: "post",
      data: {
        type: "upsells",
        grouping: grouping,
        funnel: funnel,
        from: from,
        to: to,
        filters: JSON.stringify(filters)
      }
    });

    if (!response.data) {
      return;
    }
    stats = response.data || {};

    let dataset = stats.groupedSales || {};

    chartDataLabels = Object.keys(dataset);
    monthLabels = [];
    showMonthsBelow = chartDataLabels.length > (chartWrapper.offsetWidth > 610 ? 14 : 7);

    chartDataLabels = chartDataLabels.map((label) => {
      let date;
      switch (grouping) {
        case "hourly":
          let hour = External.WebPlatform.parse(label);
          if (External.WebsiteSettings.getDateFormat() === "uk") {
            return hour;
          }
          if (hour === 0) {
            return "12";
          }
          if (hour > 12) {
            return hour - 12;
          }
          return hour;
        case "daily":
          date = new Date(label);
          if (showMonthsBelow) {
            let month = months[date.getMonth()];
            if (monthLabels.length === 0 || monthLabels[monthLabels.length - 1] !== month) {
              monthLabels.push(month);
            }
            return date.getDate();
          } else {
            return External.WebPlatform.dateToStrWithMonth(date, true, false, true, monthsShort);
          }
        case "monthly":
          date = new Date(label);
          return External.WebPlatform.dateToStrWithMonth(date, false, false, false, monthsShort);
        case "yearly":
          return label;
      }
      return label;
    });

    chartValues = Object.values(dataset);
    let upsellsData = chartValues.map((el) => el.first);
    let downsellsData = chartValues.map((el) => el.second);
    let bumpsData = chartValues.map((el) => el.third);

    let canvas = document.querySelector(".analytics-box-big canvas");
    let upsellsGradient = generateCanvasGradient(canvas, upsellsColors);
    let downsellsGradient = generateCanvasGradient(canvas, downsellsColors);
    let bumpsGradient = generateCanvasGradient(canvas, bumpsColors);

    chartData = {
      labels: chartDataLabels,
      datasets: [
        {
          label: "Upsells",
          data: upsellsData,
          backgroundColor: upsellsGradient,
          pointRadius: 0,
          pointHoverRadius: 0,
          tension: 0.1,
          lineTension: 0.3,
          fill: true,
          borderRadius: 3,
          borderColor: "transparent"
        },
        {
          label: "Downsells",
          data: downsellsData,
          backgroundColor: downsellsGradient,
          pointRadius: 0,
          pointHoverRadius: 0,
          tension: 0.1,
          lineTension: 0.3,
          fill: true,
          borderRadius: 3,
          borderColor: "transparent"
        },
        {
          label: "Bumps",
          data: bumpsData,
          backgroundColor: bumpsGradient,
          pointRadius: 0,
          pointHoverRadius: 0,
          tension: 0.1,
          lineTension: 0.3,
          fill: true,
          borderRadius: 3,
          borderColor: "transparent"
        }
      ]
    };
  }

  let filterBySource = (source) => {
    dispatch("filtersources", {
      source: source
    });
  };

  let showTopReferersBtnClick = () => {
    dispatch("showreferers");
  };
  
  let generateUtmLink = () => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      width: 520,
      buttons: [],
      noNav: true,
      noTitle: true,
      //markup: '<div class="popup-widget-wrapper bind-component"></div>',
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new UtmLinkGenerator({
              target: popup.getContentArea(),
              props: {}
            })
          );
        }
      }
    });
  };

  onMount(() => {
    reload();
  });
</script>

<div class="flex col20 f-left store-section-analytics-warapper narrow-analytics-boxes flex-col-mobile" style="background: rgb(245, 246, 250); margin-top: 0px;">
  <div class="analytics-box analytics-box-small ">
    <h3 class="flex align-center">{M.UPSELL_SALES} <span class="chart-color ml-10" style="background: #f97f7f" /></h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>
        {External.Tools.currencyToStrWithSymbol(stats.upsells)}
        <span class="increase">{stats.upsellsCount || 0} of {stats.upsellSessions || 0} ({parsePercent(stats.upsellsCount / stats.upsellSessions)})</span>
      </b>
    </h2>
  </div>
  <div class="analytics-box analytics-box-small ">
    <h3 class="flex align-center">{M.DOWNSELL_SALES} <span class="chart-color ml-10" style="background: #3da6ff" /></h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>
        {External.Tools.currencyToStrWithSymbol(stats.downsells)}
        <span class="increase">{stats.downsellsCount || 0} of {stats.downsellSessions || 0} ({parsePercent(stats.downsellsCount / stats.downsellSessions)})</span>
      </b>
    </h2>
  </div>
  <div class="analytics-box analytics-box-small">
    <h3 class="flex align-center">{M.BUMP_OFFER_SALES} <span class="chart-color ml-10" style="background: #ff9800" /></h3>
    <h2 class="col20 f-left f-28 gray-text">
      <b>
        {External.Tools.currencyToStrWithSymbol(stats.bumps)}
        <span class="increase">{stats.bumpsCount || 0} {stats.bumpsCount === 1 ? M.ORDER_SMALL : M.ORDERS_SMALL}</span>
      </b>
    </h2>
  </div>
</div>
<div class="flex f-left col20 mt-25 flex-col-mobile stats-wrapper" class:with-referers={showReferers}>
  <div class="analytics-box-big no-bpadding-mobile" class:col20={!showReferers}>
    <h2 class="col20 f-left f-28 gray-text t-left">{M.UPSELLS_DOWNSELLS_BUMPS}</h2>

    <div class="col20 f-left relative mt-25 modern-chart-box" bind:this={chartWrapper}>
      <Chart data={chartData} options={chartOptions} />
      <div class="axis">
        {#each chartDataLabels as label, i}
          <div class="tick">
            <span class="tick-label">{label}</span>
            <span class="value value-first flex align-center with-color"
              ><span class="chart-color" style="background: #f97f7f" />{External.Tools.currencyToStrWithSymbol(chartValues[i].first)}</span>
            <span class="value value-second flex align-center with-color"
              ><span class="chart-color" style="background: #3da6ff" />{External.Tools.currencyToStrWithSymbol(chartValues[i].second)}</span>
            <span class="value value-third flex align-center with-color"
              ><span class="chart-color" style="background: #ff9800" />{External.Tools.currencyToStrWithSymbol(chartValues[i].third)}</span>
          </div>
        {/each}
      </div>
      {#if grouping === "hourly"}
        <div class="col20 f-left flex flex-row am-pm-row">
          <span class="flex-1 ta-center"><p>AM</p></span>
          <span class="flex-1 ta-center"><p>PM</p></span>
        </div>
      {:else if grouping === "daily" && showMonthsBelow}
        <div class="col20 f-left flex flex-row chart-label-row">
          {#each monthLabels as label, i}
            <span
              class="flex-1"
              class:ta-left={i === 0 && monthLabels.length > 1}
              class:ta-right={i === monthLabels.length - 1 && monthLabels.length > 1}
              class:ta-center={monthLabels.length === 1 || (i > 1 && i < monthLabels.length - 1)}>
              <p>{label}</p>
            </span>
          {/each}
        </div>
      {/if}
    </div>
  </div>
  {#if showReferers}
    <div class="one-third-analytics f-right">
      <div class="analytics-box">
        <div class="col20 flex align-center space-between">
          <h2 class="col20 f-left f-28 gray-text t-left">{M.TOP_SOURCES}</h2>
          <a on:click={showTopReferersBtnClick} class="small-button blue circle-effect flex-none">{M.VIEW_ALL}</a>
        </div>
        <div class="col20 f-left mt-10">
          <span class="light-gray-text f-left t-left col20" style="font-size: 14px; line-height: 1.3;">
            {M.TOP_SOURCES_DESC}
          </span>
          <a on:click={generateUtmLink} class="small-button gray circle-effect flex-none mt-10 f-left ml-0">{M.GENERATE_LINK}</a>
        </div>
        <ul class="col20 f-left mt-25 ref-list">
          {#if stats.sources && stats.sources.length}
            {#each stats.sources as source}
              <li>
                <span
                  on:click={() => {
                    filterBySource(source.source);
                  }}>
                  {source.source}
                </span><span class="revenue">{parseNumber(source.count)} - <b>{External.Tools.currencyToStrWithSymbol(source.total)}</b></span>
              </li>
            {/each}
          {/if}
        </ul>
        {#if !stats.sources || !stats.sources.length}
        <div class="col20 f-left mt-25 mb-25">
          <div class="col20 f-left mb-15 t-center">
            <span class="material-icons-outlined fingerprint-icon inline-block" style="background: #fff;"> bubble_chart </span>
          </div>
          <h4 class="col20 f-left t-center f-16">{M.NO_SOURCES_YET}</h4>
        </div>
        {/if}
      </div>
    </div>
  {/if}
</div>
